//sadnand_gadwal

import {
  // Presales Incentive Plan
  GET_PRESALES_INCENTIVE_PLAN,
  GET_PRESALES_INCENTIVE_PLAN_DETAIL,
  GET_PRESALES_INCENTIVE_PLAN_EXPORT,
  GET_ITEM_FOR_PRE_SALES_INCENTIVE,
  //PreSales New
  GET_LEAD,
  GET_LEAD_EXPORT,
  GET_LEAD_DETAIL,
  GET_USER_FOR_LEAD_ASSIGN,
  GET_COUNTRY_CODE,
  GET_PROJECT,
  GET_SOURCE_CATEGORY,
  GET_SUB_SOURCE,
  GET_SOURCE,
  GET_LEAD_CATEGORY,
  GET_CRM_LEAD_STATUS_COUNT,
  GET_LEAD_PROJECT,
  GET_LEAD_SOURCE,
  GET_LEAD_FILTER_PROJECT,
  GET_LEAD_FILTER_SOURCE,
  GET_LEAD_OWNER_FILTER_LIST,
  GET_LEAD_SITE_VISIT,
  GET_LEAD_PROFILE,
  GET_CITY,
  GET_CUSTOMER_CURRENT_LIVING,
  GET_CUSTOMER_SUITABLE_TIME,
  GET_CUSTOMER_CONSTRUCTION_PLANNING,
  GET_CUSTOMER_BUDGET,
  GET_CRM_DIMENSION,
  GET_CUSTOMER_INCOME,
  GET_CUSTOMER_WORK_EXPERIENCE,
  GET_CUSTOMER_WORK_FUNCTION,
  GET_CUSTOMER_WORK_SECTOR,
  GET_CUSTOMER_ORGANIZATION,
  GET_EMPLOYMENT_TYPE,
  GET_CUSTOMER_PURCHASE_REASON,
  GET_SITE_VISIT_PLAN,
  GET_SITE_VISIT_PLAN_DETAIL,
  GET_SITE_VISIT_PLAN_FILTER_PROJECT,
  GET_SITE_VISIT_PLAN_FILTER_STM,
  GET_ASSIGN_TO_USER_FOR_SITE_VISIT,
  GET_IMPORT_LEAD,
  GET_IMPORT_LEAD_FILTER_UPLOADED_BY
} from "./types";

const initialState = {
  // Presales Incentive Plan
  getPresalesIncentivePlan: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPresalesIncentivePlanExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPresalesIncentivePlanDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getItemForPreSalesIncentive: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //PreSales New
  getLead: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLeadExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLeadDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getuserForLeadAssign: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCountryCode: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSourceCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSubSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLeadCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmLeadStatusCount: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLeadFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLeadFilterSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLeadOwnerFilterList: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLeadSiteVisit: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLeadProfile: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCity: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerCurrentLiving: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerSuitableTime: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerConstructionPlanning: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerBudget: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmDimension: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerIncome: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerWorkExperience: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerWorkFunction: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerWorkSector: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerOrganization: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmploymentType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerPurchaseReason: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

   getSiteVisitPlan: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

   getSiteVisitPlanDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },


   getSiteVisitPlanFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

   getSiteVisitPlanFilterStm: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },


   getAssingToUserForSiteVisit: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

     getImportedLead: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

       getImportedLeadFilterUploadedBy: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },


};
const Sales_reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    // Presales Incentive Plan
    case GET_PRESALES_INCENTIVE_PLAN:
      return Object.assign({}, state, {
        getPresalesIncentivePlan: payload
      });
    case GET_PRESALES_INCENTIVE_PLAN_EXPORT:
      return Object.assign({}, state, {
        getPresalesIncentivePlanExport: payload
      });
    case GET_PRESALES_INCENTIVE_PLAN_DETAIL:
      return Object.assign({}, state, {
        getPresalesIncentivePlanDetail: payload
      });
    case GET_ITEM_FOR_PRE_SALES_INCENTIVE:
      return Object.assign({}, state, {
        getItemForPreSalesIncentive: payload
      });
    // PreSales New
    case GET_LEAD:
      return Object.assign({}, state, { getLead: payload });
    case GET_LEAD_EXPORT:
      return Object.assign({}, state, { getLeadExport: payload });
    case GET_LEAD_DETAIL:
      return Object.assign({}, state, { getLeadDetail: payload });
    case GET_USER_FOR_LEAD_ASSIGN:
      return Object.assign({}, state, { getuserForLeadAssign: payload });
    case GET_COUNTRY_CODE:
      return Object.assign({}, state, { getCountryCode: payload });
    case GET_PROJECT:
      return Object.assign({}, state, { getProject: payload });
    case GET_SOURCE_CATEGORY:
      return Object.assign({}, state, { getSourceCategory: payload });
    case GET_SUB_SOURCE:
      return Object.assign({}, state, { getSubSource: payload });
    case GET_SOURCE:
      return Object.assign({}, state, { getSource: payload });
    case GET_LEAD_CATEGORY:
      return Object.assign({}, state, { getLeadCategory: payload });
    case GET_CRM_LEAD_STATUS_COUNT:
      return Object.assign({}, state, { getCrmLeadStatusCount: payload });
    case GET_LEAD_FILTER_PROJECT:
      return Object.assign({}, state, { getLeadFilterProject: payload });
    case GET_LEAD_FILTER_SOURCE:
      return Object.assign({}, state, { getLeadFilterSource: payload });
    case GET_LEAD_OWNER_FILTER_LIST:
      return Object.assign({}, state, { getLeadOwnerFilterList: payload });
    case GET_LEAD_SITE_VISIT:
      return Object.assign({}, state, { getLeadSiteVisit: payload });
    case GET_LEAD_PROFILE:
      return Object.assign({}, state, { getLeadProfile: payload });
    case GET_CITY:
      return Object.assign({}, state, { getCity: payload });
    case GET_CUSTOMER_CURRENT_LIVING:
      return Object.assign({}, state, { getCustomerCurrentLiving: payload });
    case GET_CUSTOMER_SUITABLE_TIME:
      return Object.assign({}, state, { getCustomerSuitableTime: payload });
    case GET_CUSTOMER_CONSTRUCTION_PLANNING:
      return Object.assign({}, state, {
        getCustomerConstructionPlanning: payload
      });
    case GET_CUSTOMER_BUDGET:
      return Object.assign({}, state, { getCustomerBudget: payload });
    case GET_CRM_DIMENSION:
      return Object.assign({}, state, { getCrmDimension: payload });
    case GET_CUSTOMER_INCOME:
      return Object.assign({}, state, { getCustomerIncome: payload });
    case GET_CUSTOMER_WORK_EXPERIENCE:
      return Object.assign({}, state, { getCustomerWorkExperience: payload });
    case GET_CUSTOMER_WORK_FUNCTION:
      return Object.assign({}, state, { getCustomerWorkFunction: payload });
    case GET_CUSTOMER_WORK_SECTOR:
      return Object.assign({}, state, { getCustomerWorkSector: payload });
    case GET_CUSTOMER_ORGANIZATION:
      return Object.assign({}, state, { getCustomerOrganization: payload });
    case GET_EMPLOYMENT_TYPE:
      return Object.assign({}, state, { getEmploymentType: payload });

    case GET_CUSTOMER_PURCHASE_REASON:
      return Object.assign({}, state, { getCustomerPurchaseReason: payload });


    case GET_SITE_VISIT_PLAN:
      return Object.assign({}, state, { getSiteVisitPlan: payload });


    case GET_SITE_VISIT_PLAN_DETAIL:
      return Object.assign({}, state, { getSiteVisitPlanDetail: payload });

          case GET_SITE_VISIT_PLAN_FILTER_PROJECT:
      return Object.assign({}, state, { getSiteVisitPlanFilterProject: payload });

          case GET_SITE_VISIT_PLAN_FILTER_STM:
      return Object.assign({}, state, { getSiteVisitPlanFilterStm: payload });


          case GET_ASSIGN_TO_USER_FOR_SITE_VISIT:
      return Object.assign({}, state, { getAssingToUserForSiteVisit: payload });

                case GET_IMPORT_LEAD:
      return Object.assign({}, state, { getImportedLead: payload });

                      case GET_IMPORT_LEAD_FILTER_UPLOADED_BY:
      return Object.assign({}, state, { getImportedLeadFilterUploadedBy: payload });
    default:
      return state;
  }
};
export default Sales_reducer;
